import script from "./goRinSyo0014.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0014.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0014.vue?vue&type=style&index=0&id=15115ecf&lang=scss"

const __exports__ = script;

export default __exports__